import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Feed from './Feed'
import About from './About'
import Profile from './Profile'
import ViewEvent from './ViewEvent'
import ViewGame from './ViewGame'
import ViewPlayer from './ViewPlayer'
import NewEvent from './NewEvent'
import Google from './Google'
import Facebook from './Facebook'

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
const Main = (props) => {
  //console.log(JSON.stringify(props));
  return (
    <main>
      <Switch>
        <Route exact path='/' render={() => <Feed fubar="1" activityList={props.activityList} />} />
        <Route path='/profile' component={Profile} />
        <Route path='/about' component={About} />
        <Route path='/eventinfo/:id' component={ViewEvent} />
        <Route path='/gameinfo/:id' component={ViewGame} />
        <Route path='/playerinfo/:id' component={ViewPlayer} />
        <Route path='/newevent' component={NewEvent} />
        <Route path='/google' component={Google} />
        <Route path='/facebook' component={Facebook} />
      </Switch>
    </main>
  );
}

export default Main



// WEBPACK FOOTER //
// ./src/containers/Main.js